module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic__mobile--CH-2bdc55c7f10a8d150112f1cf273c88a5.jpg";